/** * 图片上传 公共组件 */
<template>
  <div class="uploadWrapper">
    <vuedraggable class="vue-draggable"
                  :class="{ maxHidden: isMaxHidden }"
                  v-model="images"
                  tag="ul"
                  draggable=".draggable-item"
                  @start="onDragStart"
                  @end="onDragEnd">
      <!-- 拖拽元素 -->
      <li v-for="(item, index) in images"
          :key="item + index"
          class="draggable-item"
          :style="{ width: width + 'px', height: height + 'px' }">
        <el-image :src="item"
                  :preview-src-list="images"> </el-image>
        <div class="shadow"
             @click="onRemoveHandler(index, item)">
          <i class="el-icon-delete"></i>
        </div>
      </li>

      <!-- 上传按钮 -->
      <el-upload slot="footer"
                 ref="uploadRef"
                 class="uploadBox"
                 :style="{ width: width + 'px', height: height + 'px' }"
                 accept=".jpg,.jpeg,.png,.gif"
                 :show-file-list="false"
                 :multiple="multiple"
                 :limit="limit"
                 :before-upload="beforeUpload"
                 :on-exceed="onExceed"
                 :http-request="httpRequest"
                 :headers="headers">
        <i class="el-icon-plus uploadIcon">
          <!-- <span v-if="limit && limit!==99"
                class="limitTxt">最多{{ limit }}张</span> -->
          <span v-if="limit && limit !== 99"
                class="limitTxt">最多{{ limit }}张</span>
        </i>
      </el-upload>
    </vuedraggable>
  </div>
</template>

<script>
import vuedraggable from "vuedraggable";
import { validImgUpload } from "@/utils/validate";
import lrz from "lrz"; // 前端图片压缩插件
import tools from "@/utils/tools";
import * as publicApi from "@/http/publicApi.js";

export default {
  name: "ImgUpload",

  props: {
    // 图片数据(图片url组成的数组) 通过v-model传递
    images: {
      type: Array,
      default () {
        return [];
      }
    },
    // 限制上传的图片数量
    limit: {
      type: Number,
      default: 99
    },
    // 限制上传图片的文件大小(kb)
    size: {
      type: Number,
      default: 5120
    },
    // 是否使用图片压缩
    useCompress: {
      type: Boolean,
      default: false
    },
    // 图片显示的宽度(px)
    width: {
      type: Number,
      default: 100
    },
    // 图片显示的高度(px)
    height: {
      type: Number,
      default: 100
    },
    multiple: {
      type: Boolean,
      default: true
    },
    // 删除类型
    tb: {
      type: Number
    },
    // 显示条件
    show: {
      type: Boolean,
      default: false
    },
    // 图片主id
    pkid: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      headers: {
        token: localStorage.getItem("token")
      },
    };
  },

  computed: {
    // 控制达到最大限制时隐藏上传按钮
    isMaxHidden () {
      return this.images.length >= this.limit;
    }
  },

  watch: {
    images: {
      handler (newVal) {
        if (newVal[0] == "") {
          this.images = [];
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    // 上传图片之前
    beforeUpload (file) {
      if (this.useCompress) {
        // 图片压缩
        return new Promise((resolve, reject) => {
          lrz(file, { width: 1920 })
            .then(rst => {
              file = rst.file;
            })
            .always(() => {
              if (validImgUpload(file, this.size)) {
                resolve();
              } else {
                reject(new Error());
              }
            });
        });
      } else {
        if (validImgUpload(file, this.size)) {
          return true;
        } else {
          return false;
        }
      }
    },
    httpRequest (file) {
      const formData = new FormData();
      formData.append("img", file.file);
      publicApi.uploadImg(formData, "post").then(res => {
        if (res) {
          this.images.push(res.data);
          this.$emit("update:images", this.images);
          //console.log(this.images);
        }
      });
    },
    clear () {
      this.$refs.uploadRef.clearFiles();
    },
    // 移除单张图片
    onRemoveHandler (index, item) {
      this.$confirm("确定删除该图片?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          publicApi
            .delFile(
              {
                image_url: item,
                pkid: this.pkid,
                tb: this.tb
              },
              "post"
            )
            .then(res => {
              if (res) {
                this.images = this.images.filter((v, i) => {
                  return i !== index;
                });
                this.$refs.uploadRef.uploadFiles.splice(
                  index,
                  1
                );
                this.$emit("update:images", this.images);
              }
            });
        })
        .catch(() => { });
    },
    // 超限
    onExceed () {
      this.$refs.uploadRef.abort(); // 取消剩余接口请求
      this.$message.warning(`图片超限，最多可上传${this.limit}张图片`);
    },
    onDragStart (e) {
      e.target.classList.add("hideShadow");
    },
    onDragEnd (e) {
      e.target.classList.remove("hideShadow");
    }
  },

  components: { vuedraggable }
};
</script>

<style lang="scss" scoped>
.uploadWrapper {
    .words {
        color: red;
        font-size: 8px;
    }
    .el-upload,
    .el-upload--text {
        width: 100%;
        height: 100%;
    }
    .text {
        font-size: 12px;
        color:  $theme-color;
        text-align: left;
        width: 100%;
    }
    // 上传按钮
    .uploadIcon {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px dashed #c0ccda;
        border-radius: 6px; */
        background-color: #fbfdff;
        font-size: 20px;
        color: #999;

        .limitTxt {
            position: absolute;
            bottom: 10%;
            left: 0;
            width: 100%;
            font-size: 14px;
            text-align: center;
        }
    }

    // 拖拽
    .vue-draggable {
        display: flex;
        flex-wrap: wrap;

        .draggable-item {
            margin-right: 5px;
            margin-bottom: 5px;
            border: 1px solid #ddd;
            border-radius: 6px;
            position: relative;
            overflow: hidden;

            .el-image {
                width: 100%;
                height: 100%;
            }
            .shadow {
                position: absolute;
                top: 0;
                right: 0;
                background-color: rgba(0, 0, 0, 0.5);
                opacity: 0;
                transition: opacity 0.3s;
                color: #fff;
                font-size: 20px;
                line-height: 20px;
                padding: 2px;
                cursor: pointer;
            }
            &:hover {
                .shadow {
                    opacity: 1;
                }
            }
        }
        &.hideShadow {
            .shadow {
                display: none;
            }
        }
        &.single {
            overflow: hidden;
            position: relative;

            .draggable-item {
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
            }
        }
        &.maxHidden {
            .uploadBox {
                display: none;
            }
        }
    }
    // el-image
    .el-image-viewer__wrapper {
        .el-image-viewer__mask {
            opacity: 0.8;
        }
        .el-icon-circle-close {
            color: #fff;
        }
    }
}
</style>
